// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2373":"46d9c8741ff1573e","8670":"f8ee3050db89b21a"}[chunkId] + ".js";
};